export class AnswersAndQuestionFlow {
  public constructor( public answer: string, public nextQuestionId: string, public checked: boolean = false) {}
}
